module.exports = __webpack_public_path__ + "img/log.a76f81af.png";